import dayjs from 'dayjs';

export const toDefault = value => (value ? dayjs(value).format('YYYY/MM/DD HH:mm') : '');
export const toDateTime = value => (value ? dayjs(value).format('YYYY/MM/DD HH:mm') : '');
export const toDate = value => (value ? dayjs(value).format('YYYY/MM/DD') : '');
export const toTime = value => (value ? dayjs(value).format('HH:mm:ss') : '');
export const toDay = value => (value ? ['日', '月', '火', '水', '木', '金', '土'][dayjs(value).day()] : '');

const relativeTime = require('dayjs/plugin/relativeTime');
dayjs.extend(relativeTime);

const updateLocale = require('dayjs/plugin/updateLocale');
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  relativeTime: {
    future: '%s先',
    past: '%s前',
    s: '数秒',
    m: '1分',
    mm: '%d分',
    h: '1時間',
    hh: '%d時間',
    d: '1日',
    dd: '%d日',
    M: '1ヶ月',
    MM: '%dヶ月',
    y: '1年',
    yy: '%d年'
  }
});
export const toNow = value => (value ? dayjs(value).fromNow() : '');
